import awsdk from 'awsdk';

// DEFAULT
// EXCLUSIVE
// NORMAL

export const PracticeType = awsdk.AWSDKPracticeType;
export type PracticeType = typeof PracticeType;
